<ng-template #template>
  <sv-ng-list-item-content [model]="model" [listModel]="listModel"></sv-ng-list-item-content>
  <sv-ng-popup [popupModel]="model.popupModel"></sv-ng-popup>
</ng-template>